import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Logo from '../Logo';
import ProfileMenu from './ProfileMenu';

export default function DashboardHeader() {
  const { user } = useAuth();
  
  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-white border-b border-gray-200 z-40">
      <div className="flex items-center justify-between h-full px-6">
        <Logo />
        <div className="flex items-center space-x-4">
          <span className="text-sm text-gray-600">{user?.email}</span>
          <ProfileMenu />
        </div>
      </div>
    </header>
  );
}